// ---------------------------------------------------------------------------
// All the land there is.
//
// The sailing model used to be handed an island and asked "is this water?",
// which worked while there was one. It is now handed this instead: the same
// three questions, answered across every island in the sea.
// ---------------------------------------------------------------------------

export function createGround(islands, seaLevel) {
    return {
        seaLevel,
        islands,

        /** Does any island's grid cover this point? */
        covers(wx, wz) {
            for (const island of islands) if (island.covers(wx, wz)) return true;
            return false;
        },

        /**
         * The highest ground here, or -1 where no island has a say.
         * Highest rather than first: islands are not supposed to overlap, but
         * if two ever do, land should win over the water beside it.
         */
        topAtWorld(wx, wz) {
            let top = -1;
            for (const island of islands) {
                if (!island.covers(wx, wz)) continue;
                const h = island.topAtWorld(wx, wz);
                if (h > top) top = h;
            }
            return top;
        },
    };
}
